import React from 'react';
import * as SC from './CombinedTooltipEvolution.style';

const CombinedTooltipEvolution = ({ title, groupName, count, topBrands }) => {
    return (
        <SC.TooltipWrapper>
            <SC.TooltipTitleWrapper>
                <SC.TooltipMainTitleWrapper>
                    <SC.TooltipLabel>{title}</SC.TooltipLabel>
                    <SC.TooltipLabel>{groupName}</SC.TooltipLabel>
                </SC.TooltipMainTitleWrapper>
                <SC.TooltipLabel>(N={count})</SC.TooltipLabel>
            </SC.TooltipTitleWrapper>
            <SC.TooltipTopBrandsWrapper>
                {topBrands &&
                    topBrands.map((topItem, i) => (
                        <SC.TooltipTopBrandsRowWrapper key={i}>
                            <SC.TooltipTopBrandsRow>
                                <SC.TooltipLegend isMainBrand={topItem.isMainBrand} color={topItem.color} />
                                <SC.TooltipLabel style={{ wordBreak: 'break-word' }}>{topItem.name}</SC.TooltipLabel>
                            </SC.TooltipTopBrandsRow>
                            <SC.TooltipTopBrandsRow isMarketAverage={topItem.isDottedLine}>
                                <SC.TooltipLabel>{topItem.score}</SC.TooltipLabel>
                                {topItem.rank && <SC.TooltipLabel>{`#${topItem.rank}`}</SC.TooltipLabel>}
                            </SC.TooltipTopBrandsRow>
                        </SC.TooltipTopBrandsRowWrapper>
                    ))}
            </SC.TooltipTopBrandsWrapper>
        </SC.TooltipWrapper>
    );
};
export default CombinedTooltipEvolution;
